import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../../components/Layout';
import Reveal, { SplitWords } from '../../../components/Reveal';

import mbtiIcon from '../../../assets/images/mbti-appicon.png';
import lianwanIcon from '../../../assets/images/lianwan-appicon.png';
import eyesdwellIcon from '../../../assets/images/eyesdwell-appicon.png';
import comingSoonIcon from '../../../assets/images/comingsoon.png';

/**
 * @author Nelson
 */
const OurApp = () => {
    const navigate = useNavigate();

    const openLianWan = () => navigate('/lianwan/privacy');
    const openEyesDwell = () => navigate('/eyesdwell/privacy/en');

    return (
        <Layout title="Our App">
            <header className="page__head">
                <h1 className="page__eyebrow reveal" style={{ '--reveal-delay': '80ms' }}>
                    Our Apps
                </h1>
                <h2 className="page__title page__title--display">
                    <SplitWords text="Explore Our Creations" start={200} />
                </h2>
                <Reveal as="p" className="page__lede" delay={480}>
                    We build apps that are fun, creative, and genuinely interesting — made to surprise, delight, or simply make your day a little better.

                    From playful ideas to useful tools, we love bringing unique digital experiences to life.
                </Reveal>
            </header>

            <div className="cards">
                {/* App Card 1 */}
                <Reveal className="cards__cell" delay={560}>
                    <article className="card">
                    <div className="card__media">
                        <img
                            className="card__image"
                            src={mbtiIcon}
                            alt="YUAN MBTI: 64 Personality Test app icon"
                            loading="lazy"
                        />
                    </div>
                    <h3 className="card__title">YUAN MBTI: 64 Personality Test</h3>
                    <p className="card__desc">Beyond the traditional MBTI. With 2 new dimensions, 16 types expand into 64. YUAN visualizes your full personality structure for deeper clarity and real growth.</p>
                    </article>
                </Reveal>

                {/* App Card 2 */}
                <Reveal className="cards__cell" delay={640}>
                    <article
                        className="card card--action"
                        role="link"
                        tabIndex={0}
                        aria-label="LianWan: Party Games Pack — privacy policy"
                        onClick={openLianWan}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                event.preventDefault();
                                openLianWan();
                            }
                        }}
                    >
                    <div className="card__media">
                        <img
                            className="card__image"
                            src={lianwanIcon}
                            alt="LianWan: Party Games Pack app icon"
                            loading="lazy"
                        />
                    </div>
                    <h3 className="card__title">LianWan: Party Games Pack</h3>
                    <p className="card__desc">Bring every gathering to life with fun party games, trivia, charades, music challenges &amp; more! Perfect for group games, drinking nights, icebreakers &amp; unforgettable fun!</p>
                    <span className="card__cue" aria-hidden="true">
                        <span>→</span>
                    </span>
                    </article>
                </Reveal>

                {/* App Card 3 */}
                <Reveal className="cards__cell" delay={720}>
                    <article
                        className="card card--action"
                        role="link"
                        tabIndex={0}
                        aria-label="EyesDwell: Gaze Measurement — privacy policy"
                        onClick={openEyesDwell}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                event.preventDefault();
                                openEyesDwell();
                            }
                        }}
                    >
                    <div className="card__media">
                        <img
                            className="card__image"
                            src={eyesdwellIcon}
                            alt="EyesDwell app icon"
                            loading="lazy"
                        />
                    </div>
                    <h3 className="card__title">EyesDwell</h3>
                    <p className="card__desc">Can’t decide or just not ready to admit what you really want? Enter 2 choices and look for 8 seconds. Eyes Dwell uses your gaze to reveal what your mind already chose.</p>
                    <span className="card__cue" aria-hidden="true">
                        <span>&rarr;</span>
                    </span>
                    </article>
                </Reveal>

                {/* App Card 4 */}
                <Reveal className="cards__cell" delay={800}>
                    <article className="card">
                    <div className="card__media">
                        <img
                            className="card__image"
                            src={comingSoonIcon}
                            alt="Coming Soon"
                            loading="lazy"
                        />
                    </div>
                    <h3 className="card__title">New App Coming</h3>
                    <p className="card__desc">We’re cooking up more experiences! Follow us to stay updated with our next app launch.</p>
                    </article>
                </Reveal>
            </div>
        </Layout>
    );
};

export default OurApp;
